import { getFileUrl } from '../../../redux/actions/upload';
import AdvertisementEmptyState from './AdvertisementEmptyState';
import AdvertisementMedia from './AdvertisementMedia';
import { mountedIndices } from './playlist';
import { useAdPlayback } from './useAdPlayback';
import { useAdvertisements } from './useAdvertisements';
import { useScreenShape } from './useScreenShape';

const AdvertisementCarousel = () => {
    const ads = useAdvertisements(useScreenShape());
    const { index, turn, allFailing, advance, reportPlayed, reportFailure } = useAdPlayback(ads);

    if (ads.length === 0 || allFailing) return <AdvertisementEmptyState />;

    return (
        <div className="advertisement-carousel-wrapper">
            {mountedIndices(index, ads.length).map((i) => (
                <AdvertisementMedia
                    key={ads[i].id}
                    ad={ads[i]}
                    url={getFileUrl('advertisement', ads[i].id, ads[i].file_url)}
                    active={i === index}
                    turn={turn}
                    onEnded={advance}
                    onPlayed={reportPlayed}
                    onFailed={reportFailure}
                />
            ))}
        </div>
    );
};

export default AdvertisementCarousel;
